import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class State extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;
}
